import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { generateModulePath, timeFormatter } from '@autopass-web/domain';
import { Button } from '@autopass-web/mochi-component';

import { analytics } from '../../app-loader';
import useAppStore from '../../app-store';
import { PromotionDetailLoading } from '../../component/loading';
import { HTMLRenderer } from '../../component/quill-html-renderer';
import UserUsageStatusTag from '../../component/user-usage-status-tag';
import { ComingSoonMatcher } from '../../helper';
import usePromotionStore from '../../promotion-store';
import styles from './index.module.scss';

export const NoCoupon = ({ onClick }) => {
  return (
    <div className={styles['no-coupon']}>
      <img src="/assets/icon_nocoupon.svg" alt="no-coupon" />
      <div className={styles.message}>
        抱歉，優惠已結束囉。
        <br />
        好人總是慢一步，別擔心，你是好人！
        <br />
      </div>
      <Button type="text" theme="blue" onClick={onClick}>
        返回看更多優惠
      </Button>
    </div>
  );
};

const promotionDuration = (promotion) => {
  const matcher = new ComingSoonMatcher(promotion.startAt);
  if (matcher.isMatch()) {
    return matcher.getLabel();
  } else {
    const startAt = `${timeFormatter(promotion.startAt, 'date')}`;
    const endAt = `${timeFormatter(promotion.endAt, 'date')}`;
    return `${startAt} 至 ${endAt} 止`;
  }
};

const PromotionDetail = () => {
  const store = usePromotionStore();
  const appStore = useAppStore();
  const navigate = useNavigate();
  const generatePath = generateModulePath(
    appStore.nextModule,
    appStore.basePath,
  );

  const { detailId } = useParams();

  useEffect(() => {
    analytics.promotion_detail_pageView({
      id: detailId,
      name: appStore.distributor.name,
    });
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (appStore.app === 'guest-aps') {
      store.fetchApsPromotions({ type: 'promotionDetail', id: detailId });
    } else {
      store.fetchPromotions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const promotionDetail = (store.rawData ?? []).find((p) => p.id === detailId);

  const DetailPage = () => {
    return (
      <>
        <div className={styles.tags}>
          <div className={styles.badge}>{promotionDetail.badageLabel}</div>
          <UserUsageStatusTag
            counts={
              promotionDetail.userUsageStatus
                ? {
                    refueling:
                      promotionDetail.userUsageStatus['RefuelingPromotion'],
                    parking:
                      promotionDetail.userUsageStatus['ParkingPromotion'],
                    onStreetParking:
                      promotionDetail.userUsageStatus[
                        'OnStreetParkingPromotion'
                      ],
                  }
                : {}
            }
          />
        </div>
        <div className={styles.title}>{promotionDetail.name}</div>
        <div className={styles['promotion-tags']}>
          {promotionDetail.tags.map((tag) => {
            return (
              <>
                <img src="/assets/icon_tag_active.svg" alt="tag" />
                <span>{tag}</span>
              </>
            );
          })}
        </div>
        <div className={styles.label}>{promotionDuration(promotionDetail)}</div>
        <HTMLRenderer
          className={styles.desc}
          dangerouslySetInnerHTML={{
            __html: promotionDetail?.richTextDescription,
          }}
        />
      </>
    );
  };

  const Content = () => {
    if (store.loading || promotionDetail === null)
      return <PromotionDetailLoading />;

    if (promotionDetail) {
      return <DetailPage />;
    } else {
      return <NoCoupon onClick={() => navigate(generatePath('/'))} />;
    }
  };

  return (
    <div className={styles['promotion-detail']}>
      <Content />
    </div>
  );
};

export default PromotionDetail;
